export const STRIDE_CONTEXT_TYPE = 'conversation';
export const JIRA_CONTEXT_TYPE = 'project';
export const CONFLUENCE_CONTEXT_TYPE = 'space';